"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TempVideo = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
/**
 * @todo
 * This component should be removed once Encoder is converted to using players.
 */
exports.TempVideo = (0, react_1.forwardRef)((props, ref) => {
    const videoEl = (0, react_1.useRef)(null);
    const { source, ...other } = props;
    (0, react_1.useImperativeHandle)(ref, () => videoEl.current); // it can't be null here
    (0, react_1.useEffect)(() => {
        const el = videoEl.current;
        if (el == null || source == null || el.srcObject === source) {
            return;
        }
        if (source instanceof MediaStream) {
            el.srcObject = source;
            el.play().catch((err) => {
                // ignore because it's probably already playing
            });
        }
        else {
            source.attachTo(el);
        }
    }, [source]);
    (0, react_1.useEffect)(() => {
        if (videoEl.current == null) {
            return;
        }
        if (!(source instanceof MediaStream) && !(source === null || source === void 0 ? void 0 : source.localVideoPaused)) {
            // resume it back after unmounting
            // see: https://html.spec.whatwg.org/multipage/media.html#playing-the-media-resource:media-element-83
            if (videoEl.current.paused && !videoEl.current.ended /* && videoEl.current.readyState > 2*/) {
                videoEl.current.play();
            }
        }
    });
    // eslint-disable-next-line jsx-a11y/media-has-caption
    return react_1.default.createElement("video", { ...other, ref: videoEl });
});
//# sourceMappingURL=TempVideo.js.map